import { createContext } from 'react';

type SnackbarSeverity = 'success' | 'error' | 'info' | 'warning';

export interface ShowSnackbarInput {
  message: string;
  severity?: SnackbarSeverity;
  autoHideDuration?: number;
}

export interface SnackbarContextValue {
  showSnackbar: (input: ShowSnackbarInput) => void;
}

export const SnackbarContext = createContext<SnackbarContextValue | null>(null);
